import { createAction } from "@reduxjs/toolkit";

export const resetCollectionsTags = createAction(
  "mediaPicker/resetCollectionsTags"
);
